import { AfterViewInit, Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
// import { AdproService } from 'src/app/services/common/adPro.service';
import { ColorAdjustmentUtils } from '../../utilities/color-adjustment.utils';
// import { RestSocketService, WebSocketService } from '../services/common/web-socket.service';
// import { RestSocketService } from '../../../services/common/web-socket.service';
import { KMSNotifResponse, Data, RequestUpdNot } from 'src/app/models/common/notificaciones.model'
import { BehaviorSubject } from 'rxjs';
import { ProcessHTTPService } from 'src/app/services/process/Process';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { MessagesService } from 'src/app/services/service.index';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as CryptoJS from 'crypto-js';
import { ConfigService } from 'src/app/services/config.service';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  public codUser: string;
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  
  listProcessAdpro: any[] = [];
  notificaciones: Data[] = []
  isLoadingP$ = new BehaviorSubject<boolean>(false);
  company: any;
  username: any;
  processdata: any[] = [];
  title: string;
  body: string;
  type: string;
  table: string;
  prc_cont:string;
  closeResult: string;
  @ViewChild("mymodal") modal: any;
  @ViewChild("modalFuentes") modalFuentes: any;
  @ViewChild("backModal") backModal: any;
  program: any;
  typereport: any;
  constructor(
    // private adproService: AdproService,
    // private webSocketService: WebSocketService,
    // private restSocketService: RestSocketService,
    private processHTTPService: ProcessHTTPService,
    private auth: AuthService,
    private _messagesService: MessagesService,
    private modalService: NgbModal,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
  
    this.company = this.sessionData.selectedCompany.code;
    this.username =  this.sessionData.username;
    this.codUser = this.sessionData.username;
    this.dataprocess();
    // const defaultSecondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();
    // const darkenColor = 0.08; // Ejemplo de valor de ajuste
    // const adjustedColor = ColorAdjustmentUtils.adjustColorDarkness(defaultSecondaryColor, darkenColor);
    
    // // Asignar el valor a --secondary-color-adjusted en lugar de --secondary-color
    // document.documentElement.style.setProperty('--secondary-color-adjusted', adjustedColor);
    // this.getNotifications();
  }



  dataprocess() {
  
    this.isLoadingP$.next(true);
    this.processHTTPService.getprocessdata(this.username).subscribe(resp => {
      if (resp.isSuccessful) {
        this.processdata = resp.result;
        this.isLoadingP$.next(false);
      }
      else {
        this._messagesService.error(resp.errorMessage);
        this.isLoadingP$.next(false);
      }
    });
  }

  getCardClass(estado: string): string {
    const classes: Record<string, string> = {
      'terminado': 'bg-primary text-white',
      'verificado': 'bg-success text-white',
      'en ejecución': 'bg-warning text-dark',
      'fallido': 'bg-danger text-white'
    };
  
    return classes[estado?.toLowerCase()] || 'bg-secondary text-white';
  }
  
  getModalType(estado: string): string {
    switch (estado) {
      case 'Terminado':
        return 'I';
      case 'Verificado':
        return 'I';
      case 'En Ejecución':
        return 'A';
      case 'Fallido':
        return 'E';
      default:
        return 'I';
    }
  }
  calcTime = (date: Date) => {
    let time;
    let newDate = new Date();
    let dateNot = new Date(date);
    const diff = newDate.getTime() - dateNot.getTime();
    switch (true) {
      case diff >= 86400000:
        time = `${this.convertMsToHHMMSS(diff)['day']} días`
        break;
      case diff >= 3600000:
        time = `${this.convertMsToHHMMSS(diff)['hour']} horas`
        break;
      case diff >= 60000:
        time = `${this.convertMsToHHMMSS(diff)['minute']} minutos`
        break;
      default:
        time = `${this.convertMsToHHMMSS(diff)['second']} segundos`
        break;
    }
    return time;
  }

  convertMsToHHMMSS = (ms: number): any => {
    if(!ms) return;
    let seconds = Math.floor(ms / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    let days = Math.floor(hours / 24)
  
    seconds = seconds % 60
    minutes = minutes % 60
    hours = hours % 24
    days = days % 31

    return {second: seconds, minute: minutes, hour: hours, day: days};
  }

  open(content, data: any, number: any, program: any, tabla : any, tipo : any) {
    this.title = number + " - " + program;
    this.program=program
    this.processHTTPService.getprocesinfo(number,tabla,tipo).subscribe(resp => {
      if (resp.isSuccessful) {
        this.prc_cont = number;
        this.table = tabla;
        this.type = tipo;
        this.body = resp.result;
        this.isLoadingP$.next(false);
      }
      else {
        this._messagesService.error(resp.errorMessage);
        this.isLoadingP$.next(false);
      }
    });


    this.openModal(this.modal);
    
  }

  // openModal() {
  //   this.backModal.nativeElement.style.display = "block"
  //   this.modal.nativeElement.style.display = "block"
  //   this.modal.nativeElement.classList.add("show")
  // }
  openModal(content: any) {
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  closeModal() {
    this.backModal.nativeElement.style.display = "none"
    this.modal.nativeElement.style.display = "none"
    this.modal.nativeElement.classList.remove("show")
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  

  itemClick(data: any) {
    this.isLoadingP$.next(true);
    this.processHTTPService.getprocesupdate(data).subscribe(resp => {
      if (resp.isSuccessful) {
        this.dataprocess();
        this.isLoadingP$.next(false);
      }
      else {
        this._messagesService.error(resp.errorMessage);
        this.isLoadingP$.next(false);
      }
    });
  }

  logReport(){
    


    this.isLoadingP$.next(true);
    this.processHTTPService.GetReport(this.program).subscribe(resp => {
      if (resp.isSuccessful) {
        this.typereport = resp.result;


if(this.typereport!="SR")
{
  let tokens = this.newGuid();
  let cache = this.newGuid();
  // const url='/visor.aspx?id=S'+ this.table.slice(0, 2)+'LOGER'+'.rpt&promptex0='+this.username +'&sf=%7BCN_LOGER.PRC_CONT%7D='+this.prc_cont+'';
  const url='/visor.aspx?id=S'+ this.table.slice(0, 2)+'LOGER'+'.rpt&promptex0='+this.username +'&sf=%7B'+this.table+'.PRC_CONT%7D='+this.prc_cont+'';
  window.open(`${this.configService.config.urlReportCrytal}${url}&token={${tokens}}&cache=${cache}`, "_blank");

 
}
else{
  let reportName = '';
  let lurl = '';
  let lselectformula = '';
  const ltable = this.table;
  const report = this.table.slice(0, 2) + 'LOGER';
  reportName = `s${report.toLowerCase()}`;
  this.type === 'E' ? lselectformula = `&sf=${ltable}.PRC_CONT=${this.prc_cont} AND ${ltable}.LOG_TIPO='E'` :
    lselectformula = `&sf=${ltable}.PRC_CONT=${this.prc_cont}`;
  lurl = `promptex0=${this.company}` + lselectformula;
  const key = CryptoJS.enc.Utf8.parse('5388198671491268');
  const iv = CryptoJS.enc.Utf8.parse('5388198671491268');
  let lurlEncr = CryptoJS.AES.encrypt(lurl.trim(), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  }).toString();
  //remplazar caracteres especiales
  lurlEncr = lurlEncr.replace(/=/g, '%3D');
  lurlEncr = lurlEncr.replace(/>/g, '%3E');
  lurlEncr = lurlEncr.replace(/</g, '%3C');
  lurlEncr = lurlEncr.replace(/[+]/g, '%2B');
  lurlEncr = lurlEncr.replace(/[/]/g, '%2F');
  window.open(`${this.configService.config.urlReportServer}${reportName}&${lurlEncr}`, "_blank");   
}


        this.isLoadingP$.next(false);
      }
      else {
        this._messagesService.error(resp.errorMessage);
        this.isLoadingP$.next(false);
      }
    });



 
  }

  

newGuid(): string {
 
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, (c) => {

      const r =
        crypto.getRandomValues(
          new Uint8Array(1)
        )[0] & 15;

      const v =
        c === 'x'
          ? r
          : (r & 0x3 | 0x8);

      return v.toString(16);

    });
}
}
